import { SelectField as MetxSelectField } from "@mm/metx-design-system";
import type { ComponentProps } from "react";

export type SelectFieldProps = ComponentProps<typeof MetxSelectField>;

export function SelectField(props: SelectFieldProps) {
  return <MetxSelectField {...props} />;
}
